"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonsInsuranceBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
class MonsInsuranceBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.MONS_INSURANCE_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU06',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(-2).any.asterix();
                    }).megacredits(-3);
                    b.text('(Each opponent decreases their M€ production 2 steps and loses 3 M€.)', Size_1.Size.TINY, false, false);
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.action('Gain 1 TR.', (eb) => {
                            eb.empty().startAction.tr(1);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.effect('When you decrease the bot’s production or resources, gain 3 M€.', (eb) => {
                            eb.production((pb) => pb.wild(1).any).or().minus().nbsp(Size_1.Size.TINY).wild(1).any;
                            eb.startEffect.megacredits(3);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        for (const p of player.game.getPlayers()) {
            p.addProduction(Resources_1.Resources.MEGACREDITS, -2, { log: true });
            p.deductResource(Resources_1.Resources.MEGACREDITS, 3, { log: true });
        }
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const game = player.game;
        game.automaBotVictoryPointsBreakdown.terraformRating++;
        game.log('${0} action: Gain 1 TR', (b) => b.card(this));
        return undefined;
    }
    static resolveMonsInsuranceBot(attacker) {
        attacker.addResource(Resources_1.Resources.MEGACREDITS, 3);
        attacker.game.log('${0} gained 3 M€ from Mons Insurance bot', (b) => b.player(attacker));
    }
}
exports.MonsInsuranceBot = MonsInsuranceBot;
//# sourceMappingURL=MonsInsuranceBot.js.map